import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faMagnifyingGlass = magnifyingGlass('classic', 'thin');
export const falMagnifyingGlass = magnifyingGlass('classic', 'light');
export const fatMagnifyingGlass = magnifyingGlass('classic', 'thin');
export const fadMagnifyingGlass = magnifyingGlass('duotone', 'thin');
export const fasMagnifyingGlass = magnifyingGlass('classic', 'solid');
export const farMagnifyingGlass = magnifyingGlass('classic', 'regular');

export default function magnifyingGlass(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'magnifying-glass',
    512, // width
    512, // height
    'f002', // unicode
    [
      [
        'classic',
        'solid',
        'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z',
      ],
      [
        'classic',
        'regular',
        'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z',
      ],
      [
        'classic',
        'light',
        'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z',
      ],
      [
        'classic',
        'thin',
        'M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z',
      ],
      [
        'duotone',
        'thin',
        [
          'M16 208a192 192 0 1 0 384 0A192 192 0 1 0 16 208z',
          'M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z',
        ],
      ],
    ]
  );
}
